import React from 'react';


const LanguageItem = ({company, switchCompany, handleRequestClose}) => {
  const {name} = company;
  return (
    <li className="pointer" onClick={() => {
      handleRequestClose();
      switchCompany(company);
    }}>
      <div className="d-flex align-items-center">
        <h4 className="mb-0 ml-2">{name}</h4>
      </div>
    </li>
  );
};

export default LanguageItem;
